<!--课时/开课时间/有效期-->
<template>
  <div class="coursePeriod">
    <!-- 课时669999 -->
    <!--    v-if="period || startTime || courseBaseData.validPeriodType === 1"-->
    <p v-if="skuHourOnly || skuHourMap[classHourKey]">共{{ skuHourOnly || skuHourMap[classHourKey] }}课时</p>
    <p v-if="startTime">开课时间：{{ startTime }}</p>
    <p v-if="courseBaseData.validPeriodType !== 1">
      <template v-if="JSON.stringify(courseBaseData) !== '{}'">
        有效期：{{
        courseBaseData.validPeriodType === 2
        ? `${courseBaseData.validDuration}天`
        : `${showTime(courseBaseData.invalidTime)}`
        }}
      </template>
    </p>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { dateTime } from '../../../utils/tools';

export default {
  props: ['courseBaseData'],
  data() {
    return {
      period: '', // 课时
      startTime: '', // 开课时间
      skuHourMap: {},
      classHourKey: '',
      skuHourOnly: '',
    };
  },
  computed: {
    ...mapState(['courseSimpleData']),
  },
  mounted() {
    PubSub.subscribe('course_detail_change_classtime', (msg, data) => {
      console.log('订阅', this.skuHourMap, data);
      this.classHourKey = data;
      // this.$forceUpdate();
    });
  },
  destroyed() {
    PubSub.unsubscribe('course_detail_change_classtime');
  },
  watch: {
    courseBaseData(data) {
      this.init(data);
    },
  },
  methods: {
    ...mapActions(['saveCourseSimpleData']),
    init(data) {
      console.log('courseBaseData', data);
      const { productSkuRespVOList } = data;
      const skuHourMap = {};

      productSkuRespVOList?.forEach(item => {
        const { specJson, classPeriod } = item;
        const specStr = JSON.parse(specJson)
          .map(item => item.value)
          .join('+');
        skuHourMap[specStr] = classPeriod;
      });

      this.skuHourMap = skuHourMap;
      if (productSkuRespVOList.length === 1) {

        this.skuHourOnly = productSkuRespVOList[0]?.classPeriod;
      }
      console.log('productSkuRespVOList', skuHourMap, productSkuRespVOList);

      if (data && data.productAttributeRespVOS) {
        data.productAttributeRespVOS.forEach(element => {
          if (element.extendAttributeNameEn === 'classPeriod') {
            this.period = element.dataJson;
          }
          if (element.extendAttributeNameEn === 'startTime') {
            const tempTime = dateTime(new Date(this.iosTimeReplace(element.dataJson)).getTime());
            const startTime = `${tempTime.year}.${tempTime.month}.${tempTime.day}`;
            this.startTime = startTime;
          }
        });
        const vuexData = this.courseSimpleData;
        vuexData.classPeriod = this.period;
        vuexData.startTime = this.startTime;
        this.saveCourseSimpleData(vuexData);
      }
    },
    // ios 时间 '-' 处理
    iosTimeReplace(timeIt) {
      return (timeIt || '').replace(/-/g, '/');
    },
    // 转换时间
    showTime(time) {
      const temp = dateTime(new Date(this.iosTimeReplace(time)).getTime());
      return `${temp.year}.${temp.month}.${temp.day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.coursePeriod {
  display: flex;
  align-items: center;
  padding: 36px 0;
  > p {
    padding: 0 15px;
    color: #787878;
    font-size: 22px;
    border-right: 1px solid #e4e4e4;
  }
  > p:first-child {
    padding: 0 15px 0 0;
  }
  > p:last-child {
    border: none;
  }
}
</style>
